export default __webpack_public_path__ + "static/media/top-k-2-thumb.79ae2056.jpg";